export default {
  ajaxUrl: null,
  data: {},
  loaderContainer: null,
  onBeforeRedirect: null,
  onComplete: null,
};



// WEBPACK FOOTER //
// ./assets/js/cf-ajax-handler/defaults.js